import { render, staticRenderFns } from "./PromoCodeBadge.vue?vue&type=template&id=ca89521e&scoped=true&"
import script from "./PromoCodeBadge.vue?vue&type=script&lang=js&"
export * from "./PromoCodeBadge.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodeBadge.vue?vue&type=style&index=0&id=ca89521e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca89521e",
  null
  
)

export default component.exports